import React, { useState, useEffect } from 'react';
import './BotActivation.css';
import PopupMessage from '../components/PopupMessage';

const BotActivation = () => {
  const [amount, setAmount] = useState('');
  const [popup, setPopup] = useState(null);
  const [submittedAmount, setSubmittedAmount] = useState('');
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const savedAmount = localStorage.getItem('vortrex_usdt_amount');
    const warningFlag = localStorage.getItem('vortrex_warning_triggered');

    if (savedAmount) {
      setAmount(savedAmount);
      setSubmittedAmount(savedAmount);
    }

    if (warningFlag === 'true') {
      setShowWarning(true);
    }
  }, []);

  const handleSubmit = () => {
    if (!amount || parseFloat(amount) <= 0) {
      setPopup({ message: '❌ Please enter a valid amount.', type: 'error' });
      return;
    }

    localStorage.setItem('vortrex_usdt_amount', amount);
    localStorage.removeItem('vortrex_warning_triggered'); // clear old warning
    setSubmittedAmount(amount);
    setShowWarning(false);

    setPopup({
      message: `✅ You submitted ${amount} USDT. Make sure this amount is available in your wallet.`,
      type: 'success'
    });

    setTimeout(() => {
      setShowWarning(true);
      localStorage.setItem('vortrex_warning_triggered', 'true');
    }, 120000);
  };

  return (
    <div className="bot-activation-container">
      <div className="loader-box">
        <div className="loader" />
        <h2 className="activation-title">🔓 Waiting for Trading mode.</h2>
        <p className="activation-subtext">
          Now decide how much USDT you'd like to allow VORTREX to use for trading.
        </p>

        <div className="stats-grid">
          <div className="stat-box"><div className="stat-title">Trades Today</div><div className="stat-value">0</div></div>
          <div className="stat-box"><div className="stat-title">Daily Profit</div><div className="stat-value">0</div></div>
          <div className="stat-box"><div className="stat-title">Wallet Balance</div><div className="stat-value">0</div></div>
          <div className="stat-box"><div className="stat-title">Volume</div><div className="stat-value">$0</div></div>
        </div>

        <div className="permission-box">
          <p><strong>Enter how much USDT you allow VORTREX to trade:</strong></p>
          <input
            type="number"
            placeholder="Enter USDT amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          <button onClick={handleSubmit}>Activate Bot</button>
          <p className="permission-info">
            ⚠️ Ensure you have this amount in your wallet. VORTREX will only trade if funds are available.
          </p>

          {submittedAmount && (
            <div className="confirmation-box">
              {showWarning ? (
                <div style={{ marginTop: '15px', color: '#e11d48', fontWeight: 'bold' }}>
                  ⚠️ Your funds are not eligible for trading. Please try again.
                </div>
              ) : (
                <>
                  <p>✅ Trading initialized with <strong>{submittedAmount} USDT</strong>. Slots will be set automatically by the bot.</p>
                  <p className="confirmation-info">
                    Your bot is now in <strong>activating mode</strong>. Make sure your wallet has the entered USDT amount.<br />
                    <span style={{ color: '#facc15' }}>⚠️ Otherwise, the AI Bot will not enter Trading Mode.</span>
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {popup && <PopupMessage message={popup.message} type={popup.type} onClose={() => setPopup(null)} />}
    </div>
  );
};

export default BotActivation;
